# frozen_string_literal: true

require_relative 'sell_shares'

module Engine
  module Action
    class CorporateSellShares < SellShares
    end
  end
end
